import { AINestedSubject } from '../types/training';

// Save-planning helpers for Edit AI-led nested program. A module is linked to
// its Moodle quiz only through `moodleId` in the stored program structure;
// losing it (moodleId 0) means the module's question edits can't be saved
// and re-adding the module creates duplicate quizzes.

const allModules = (subjects: AINestedSubject[]) =>
    subjects.flatMap(s => s.chapters.flatMap(c => c.modules));

// The program structure stored on the Moodle program (UI-only fields
// stripped). `createdQuizIds` maps module id -> quiz id for quizzes created
// during this save, so they're stored even though component state hasn't
// caught up yet.
export const buildStoredHierarchy = (subjects: AINestedSubject[], createdQuizIds: Map<string, number> = new Map()) =>
    subjects.map(s => ({
        id: s.id, name: s.name,
        chapters: s.chapters.map(c => ({
            id: c.id, name: c.name,
            modules: c.modules.map(m => ({
                id: m.id, moodleId: createdQuizIds.get(m.id) || (m as any).moodleId || 0,
                name: m.name, description: m.description,
                difficulty: m.difficulty, questionCount: m.questionCount,
                estimatedTime: m.estimatedTime, attemptLimit: m.attemptLimit,
                deadline: (m as any).deadline || 0,
            })),
        })),
    }));

// Existing modules whose questions were opened (and so may have been edited)
// but that have no quiz id - their questions can't be saved. Callers must
// stop and say so rather than silently skipping them.
export const findUnlinkedEditedModules = (subjects: AINestedSubject[]) =>
    allModules(subjects).filter((m: any) => m.isExisting && !(m.moodleId > 0) && m.questionsLoaded);
